import React, { useState, useEffect } from 'react';

const mono = { fontFamily: "'DM Mono', monospace" };
const sans = { fontFamily: "'DM Sans', sans-serif" };
const label = { ...mono, fontSize: 7.5, letterSpacing: '0.22em', textTransform: 'uppercase', color: '#7A5230', marginBottom: 16, marginTop: 32, display: 'flex', alignItems: 'center', gap: 12 };
const CL = () => <span style={{ width: 20, height: 1, background: '#7A5230', flexShrink: 0 }} />;

const card = {
  background: '#FFFFFF', border: '1px solid rgba(7,25,42,0.10)',
  padding: '20px 24px', marginBottom: 16,
};

const inputStyle = {
  ...mono, fontSize: 12, color: '#0A1828', background: '#FFFFFF',
  border: '1px solid rgba(7,25,42,0.12)', padding: '10px 14px', width: '100%',
  outline: 'none',
};

const btnStyle = {
  ...mono, fontSize: 9, letterSpacing: '0.12em', textTransform: 'uppercase',
  background: '#7A5230', color: '#F5F0E8', border: 'none',
  padding: '12px 20px', cursor: 'pointer', minHeight: 48, marginTop: 8,
};

function Toggle({ label: text, storageKey }) {
  const [on, setOn] = useState(() => localStorage.getItem(storageKey) !== 'false');
  const toggle = () => {
    const next = !on;
    setOn(next);
    localStorage.setItem(storageKey, String(next));
  };
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid rgba(7,25,42,0.04)' }}>
      <span style={{ ...sans, fontSize: 13, color: '#0A1828' }}>{text}</span>
      <button onClick={toggle} style={{
        width: 40, height: 22, background: on ? '#7A5230' : 'rgba(10,24,40,0.12)',
        border: 'none', cursor: 'pointer', position: 'relative', padding: 0,
      }}>
        <span style={{
          position: 'absolute', top: 2, left: on ? 20 : 2,
          width: 18, height: 18, background: '#FFFFFF',
          transition: 'left 0.15s',
        }} />
      </button>
    </div>
  );
}

function VPCalendlySection() {
  const [url, setUrl] = useState('');
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    fetch('/api/advisor/profile', { credentials: 'include' })
      .then(r => r.ok ? r.json() : {})
      .then(d => { if (d.calendly_url) setUrl(d.calendly_url); })
      .catch(() => {});
  }, []);
  const save = () => {
    fetch('/api/advisor/calendly', {
      method: 'PATCH', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ calendly_url: url }),
    })
      .then(() => { setSaved(true); setTimeout(() => setSaved(false), 2000); })
      .catch(() => {});
  };
  return (
    <div style={card}>
      <div style={{ ...mono, fontSize: 8, letterSpacing: '0.12em', color: 'rgba(10,24,40,0.4)', textTransform: 'uppercase', marginBottom: 6 }}>Your Personal Calendly (optional)</div>
      <div style={{ ...sans, fontSize: 11, color: '#7A94A8', marginBottom: 8 }}>Overrides firm default for your engagements</div>
      <input style={inputStyle} value={url} onChange={e => setUrl(e.target.value)} placeholder="https://calendly.com/your-name/..." />
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
        <button onClick={save} style={btnStyle}>Save</button>
        {saved && <span style={{ ...mono, fontSize: 9, color: '#2D6A4F' }}>Saved</span>}
      </div>
    </div>
  );
}

export default function Settings() {
  const name = localStorage.getItem('cordis_advisor_name') || 'User';
  const email = localStorage.getItem('cordis_advisor_email') || '--';
  const role = localStorage.getItem('cordis_advisor_role') || 'vp';

  const [calendly, setCalendly] = useState('');
  const [calSaved, setCalSaved] = useState(false);
  const [fee, setFee] = useState(() => localStorage.getItem('cordis_default_fee') || '85000');
  const [tier, setTier] = useState(() => localStorage.getItem('cordis_default_tier') || 'standard');

  useEffect(() => {
    fetch('/api/state/calendly_default', { credentials: 'include' })
      .then(r => r.ok ? r.text() : '')
      .then(text => { if (text) setCalendly(text.replace(/"/g, '')); })
      .catch(() => {});
  }, []);

  function saveCalendly() {
    fetch('/api/state/calendly_url', {
      method: 'PATCH', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ value: calendly }),
    })
      .then(() => { setCalSaved(true); setTimeout(() => setCalSaved(false), 2000); })
      .catch(() => {});
  }

  function saveFee(val) {
    setFee(val);
    localStorage.setItem('cordis_default_fee', val);
  }
  function saveTier(val) {
    setTier(val);
    localStorage.setItem('cordis_default_tier', val);
  }

  return (
    <div style={{ padding: '32px 40px', maxWidth: 600, background: '#FAFAF8', minHeight: '100vh' }}>
      <div style={{ ...label, marginTop: 0 }}><CL />SETTINGS</div>

      {/* ACCOUNT */}
      <div style={label}><CL />ACCOUNT</div>
      <div style={card}>
        <div style={{ marginBottom: 12 }}>
          <div style={{ ...mono, fontSize: 8, letterSpacing: '0.12em', color: 'rgba(10,24,40,0.4)', textTransform: 'uppercase', marginBottom: 4 }}>Display Name</div>
          <div style={{ ...sans, fontSize: 14, color: '#0A1828' }}>{name}</div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <div style={{ ...mono, fontSize: 8, letterSpacing: '0.12em', color: 'rgba(10,24,40,0.4)', textTransform: 'uppercase', marginBottom: 4 }}>Email</div>
          <div style={{ ...sans, fontSize: 14, color: '#0A1828' }}>{email}</div>
        </div>
        <div>
          <div style={{ ...mono, fontSize: 8, letterSpacing: '0.12em', color: 'rgba(10,24,40,0.4)', textTransform: 'uppercase', marginBottom: 4 }}>Role</div>
          <span style={{
            ...mono, fontSize: 8, letterSpacing: '0.08em', padding: '3px 8px',
            background: role === 'admin' ? '#7A5230' : '#0A1828',
            color: '#F5F0E8', textTransform: 'uppercase',
          }}>{role}</span>
        </div>
      </div>

      {/* NOTIFICATIONS */}
      <div style={label}><CL />NOTIFICATIONS</div>
      <div style={card}>
        <Toggle label="Slack notifications" storageKey="cordis_notif_slack" />
        <Toggle label="Email notifications" storageKey="cordis_notif_email" />
        <Toggle label="In-app notifications" storageKey="cordis_notif_inapp" />
      </div>

      {/* CALENDLY */}
      <div style={label}><CL />CALENDLY</div>
      <div style={card}>
        <div style={{ ...mono, fontSize: 8, letterSpacing: '0.12em', color: 'rgba(10,24,40,0.4)', textTransform: 'uppercase', marginBottom: 6 }}>Firm Default Calendly URL</div>
        <input
          style={inputStyle}
          value={calendly}
          onChange={e => setCalendly(e.target.value)}
          placeholder="https://calendly.com/..."
        />
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
          <button onClick={saveCalendly} style={btnStyle}>Save</button>
          {calSaved && <span style={{ ...mono, fontSize: 9, color: '#2D6A4F' }}>Saved</span>}
        </div>
      </div>
      <VPCalendlySection />

      {/* ENGAGEMENT DEFAULTS */}
      <div style={label}><CL />ENGAGEMENT DEFAULTS</div>
      <div style={card}>
        <div style={{ marginBottom: 12 }}>
          <div style={{ ...mono, fontSize: 8, letterSpacing: '0.12em', color: 'rgba(10,24,40,0.4)', textTransform: 'uppercase', marginBottom: 6 }}>Default Fee Amount</div>
          <input style={inputStyle} value={fee} onChange={e => saveFee(e.target.value)} />
        </div>
        <div>
          <div style={{ ...mono, fontSize: 8, letterSpacing: '0.12em', color: 'rgba(10,24,40,0.4)', textTransform: 'uppercase', marginBottom: 6 }}>Default Tier</div>
          <select style={{ ...inputStyle, cursor: 'pointer' }} value={tier} onChange={e => saveTier(e.target.value)}>
            <option value="standard">Standard</option>
            <option value="premium">Premium</option>
            <option value="charter_250">Charter 250</option>
            <option value="charter_500">Charter 500</option>
            <option value="charter_1m">Charter 1M</option>
          </select>
        </div>
      </div>

      {/* QUICK LINKS */}
      <div style={label}><CL />QUICK LINKS</div>
      <div style={card}>
        {[
          { label: 'VP Onboarding Guide', href: '/api/onboarding' },
          { label: 'Weekly Summary', href: '/api/reports/weekly-summary' },
          { label: 'Dropbox Sign Setup', href: 'https://github.com/ronsmith6820-cordis/mri-workbench/blob/master/DROPBOX_SIGN_SETUP.md' },
          { label: 'BLOCKERS Log', href: 'https://gitlab.com/ronsmith6820-cordis/mri-workbench/-/blob/master/BLOCKERS.md' },
        ].map(link => (
          <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer" style={{
            display: 'block', ...mono, fontSize: 10, color: '#7A5230', textDecoration: 'none',
            padding: '8px 0', borderBottom: '1px solid rgba(7,25,42,0.04)',
          }}>{link.label}</a>
        ))}
      </div>
    </div>
  );
}
